// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  border-bottom: 1px solid var(--border);
}

.nav-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 64px;
  display: flex;
  align-items: center;
  gap: 32px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  flex-shrink: 0;
}

.logo-img{height:50px;width:auto;display:block}

.logo-sub { display: none; }

.nav-links {
  display: flex;
  gap: 24px;
  list-style: none;
  flex: 1 1;
}

.nav-links a {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--muted);
  text-decoration: none;
  transition: color 0.2s;
}
.nav-links a:hover { color: var(--p1); }

.nav-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.nav-link-plain {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--p1);
  text-decoration: none;
  transition: opacity 0.2s;
}
.nav-link-plain:hover { opacity: 0.75; }

.nav-cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--grad);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 9px 20px;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  text-decoration: none;
  transition: opacity 0.2s, transform 0.15s;
}
.nav-cta:hover { opacity: 0.9; transform: translateY(-1px); }

.nav-burger {
  display: none;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: #fff;
  color: var(--p1);
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: auto;
}

.nav-drawer {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  border-top: 1px solid var(--border);
  background: #fff;
  padding: 18px 20px 26px;
  box-shadow: 0 18px 34px rgba(17, 24, 39, 0.12);
}

.nav-drawer ul {
  list-style: none;
  display: flex;
  flex-direction: column;
}

.nav-drawer ul a {
  display: block;
  padding: 14px 2px;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text);
  text-decoration: none;
  border-bottom: 1px solid var(--border);
}

.nav-drawer-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 22px;
}

.nav-drawer-actions .btn-primary,
.nav-drawer-actions .btn-outline {
  width: 100%;
}

@media (max-width: 640px) {
  .nav-links { display: none; }
  .nav-actions { display: none; }
  .nav-burger { display: flex; }
  .nav-drawer { display: block; }
  .nav-inner { gap: 12px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,cAAc;AAChB;;AAEA,UAAU,WAAW,CAAC,UAAU,CAAC,aAAa;;AAE9C,YAAY,aAAa,EAAE;;AAE3B;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;AACA,qBAAqB,gBAAgB,EAAE;;AAEvC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA,wBAAwB,aAAa,EAAE;;AAEvC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yCAAyC;AAC3C;AACA,iBAAiB,YAAY,EAAE,2BAA2B,EAAE;;AAE5D;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,8BAA8B;EAC9B,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa,aAAa,EAAE;EAC5B,eAAe,aAAa,EAAE;EAC9B,cAAc,aAAa,EAAE;EAC7B,cAAc,cAAc,EAAE;EAC9B,aAAa,SAAS,EAAE;AAC1B","sourcesContent":[".navbar {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: #fff;\n  border-bottom: 1px solid var(--border);\n}\n\n.nav-inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  gap: 32px;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n  flex-shrink: 0;\n}\n\n.logo-img{height:50px;width:auto;display:block}\n\n.logo-sub { display: none; }\n\n.nav-links {\n  display: flex;\n  gap: 24px;\n  list-style: none;\n  flex: 1;\n}\n\n.nav-links a {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--muted);\n  text-decoration: none;\n  transition: color 0.2s;\n}\n.nav-links a:hover { color: var(--p1); }\n\n.nav-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.nav-link-plain {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--p1);\n  text-decoration: none;\n  transition: opacity 0.2s;\n}\n.nav-link-plain:hover { opacity: 0.75; }\n\n.nav-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--grad);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  padding: 9px 20px;\n  font-size: 0.88rem;\n  font-weight: 700;\n  cursor: pointer;\n  text-decoration: none;\n  transition: opacity 0.2s, transform 0.15s;\n}\n.nav-cta:hover { opacity: 0.9; transform: translateY(-1px); }\n\n.nav-burger {\n  display: none;\n  width: 42px;\n  height: 42px;\n  border-radius: 10px;\n  border: 1px solid var(--border);\n  background: #fff;\n  color: var(--p1);\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-left: auto;\n}\n\n.nav-drawer {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  max-height: calc(100vh - 64px);\n  overflow-y: auto;\n  border-top: 1px solid var(--border);\n  background: #fff;\n  padding: 18px 20px 26px;\n  box-shadow: 0 18px 34px rgba(17, 24, 39, 0.12);\n}\n\n.nav-drawer ul {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n}\n\n.nav-drawer ul a {\n  display: block;\n  padding: 14px 2px;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text);\n  text-decoration: none;\n  border-bottom: 1px solid var(--border);\n}\n\n.nav-drawer-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 22px;\n}\n\n.nav-drawer-actions .btn-primary,\n.nav-drawer-actions .btn-outline {\n  width: 100%;\n}\n\n@media (max-width: 640px) {\n  .nav-links { display: none; }\n  .nav-actions { display: none; }\n  .nav-burger { display: flex; }\n  .nav-drawer { display: block; }\n  .nav-inner { gap: 12px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
